/* tslint:disable */
/* eslint-disable */
export enum CustomerOnlinePaymentMethodEnum {
  None = 'None',
  Poli = 'Poli'
}
